import { createContext, useContext, useEffect, useState } from "react";
import { getContent } from "../lib/api";
import { DEFAULTS } from "../data/contentRegistry";

const ContentContext = createContext({ t: (k, d) => d ?? DEFAULTS[k] ?? "", refresh: () => {} });

export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});

  const refresh = () =>
    getContent()
      .then((data) => setOverrides(data || {}))
      .catch(() => {});

  useEffect(() => {
    refresh();
    // Re-fetch latest content when the tab regains focus / becomes visible,
    // so admin edits show up without requiring a manual hard refresh.
    const onFocus = () => refresh();
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  const t = (key, fallback) => {
    const v = overrides[key];
    if (v !== undefined && v !== null && v !== "") return v;
    return fallback !== undefined ? fallback : DEFAULTS[key] ?? "";
  };

  return (
    <ContentContext.Provider value={{ t, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};
